import Layout from "./Layout.jsx";
import ScrollToTop from "@/components/ScrollToTop";

import Discover from "./Discover";
import Upload from "./Upload";
import Home from "./Home";
import Settings from "./Settings";
import Profile from "./Profile";
import Leaderboard from "./Leaderboard";
import AnnualLeaderboard from "./AnnualLeaderboard";
import Archive from "./Archive";
import Inbox from "./Inbox";
import Notifications from "./Notifications";
import MyTracks from "./MyTracks";
import MyReviews from "./MyReviews";
import Vote from "./Vote";
import ReceivedFeedback from "./ReceivedFeedback";
import BuyCredits from "./BuyCredits";
import TrackDetails from "./TrackDetails";
import PublicProfile from "./PublicProfile";
import DevDashboard from "./DevDashboard";
import Moderation from "./Moderation";
import HowItWorks from "./HowItWorks";
import ForArtists from "./ForArtists";
import ForCurators from "./ForCurators";
import SubmithubAlternative from "./SubmithubAlternative";
import PlaylistPushAlternative from "./PlaylistPushAlternative";
import CheapestPlaylistPitching from "./CheapestPlaylistPitching";
import SoundopeVs from "./SoundopeVs";
import FAQ from "./FAQ";
import CookiePolicy from "./CookiePolicy";
import EULA from "./EULA";
import EULAAcceptance from "./EULAAcceptance";
import TOS from "./TOS";
import TOSAcceptance from "./TOSAcceptance";
import PrivacyPolicy from "./PrivacyPolicy";
import PrivacyPolicyAcceptance from "./PrivacyPolicyAcceptance";
import Report from "./Report";
import Disclaimer from "./Disclaimer";
import AcceptableUsePolicy from "./AcceptableUsePolicy";
import ReviewerLeaderboard from "./ReviewerLeaderboard";
import ViewFeedback from "./ViewFeedback";
import FreshDopeSounds from "./FreshDopeSounds";
import Auth from "./Auth";
import ResetPassword from "./ResetPassword";
import ForgotPassword from "./ForgotPassword";
import Shop from "./Shop";
import GrowthProgram from "./GrowthProgram";
import Submit from "./Submit";
import SubmitOptions from "./SubmitOptions";
import SubmitSuccess from "./SubmitSuccess";
import PremiumPitch from "./PremiumPitch";
import PurchaseHistory from "./PurchaseHistory";
import Cashout from "./Cashout";
import CuratorSubmit from "./CuratorSubmit";
import Tools from "./Tools";
import DeadWords from "./DeadWords";
import WhatWeOffer from "./WhatWeOffer";
import NotFound from "./NotFound";
import Blog from "./Blog";
import BlogPost from "./BlogPost";
import DeleteAccount from "./DeleteAccount";
import Support from "./Support";
import Contest from "./Contest";

import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { RESET_PASSWORD_ROUTE, FORGOT_PASSWORD_ROUTE } from "../constants/routes";

const PAGES = {
    Discover,
    Upload,
    Home,
    Settings,
    Profile,
    Leaderboard,
    AnnualLeaderboard,
    Archive,
    Inbox,
    Notifications,
    MyTracks,
    MyReviews,
    Vote,
    ReceivedFeedback,
    BuyCredits,
    TrackDetails,
    PublicProfile,
    DevDashboard,
    Moderation,
    HowItWorks,
    ForArtists,
    ForCurators,
    FAQ,
    CookiePolicy,
    EULA,
    EULAAcceptance,
    TOS,
    TOSAcceptance,
    PrivacyPolicy,
    PrivacyPolicyAcceptance,
    Report,
    Disclaimer,
    AcceptableUsePolicy,
    ReviewerLeaderboard,
    ViewFeedback,
    FreshDopeSounds,
    Auth,
    ResetPassword,
    ForgotPassword,
    Submit,
    SubmitOptions,
    PremiumPitch,
    PurchaseHistory,
    Shop,
    GrowthProgram,
    Cashout,
    CuratorSubmit,
    Tools,
    DeadWords,
    WhatWeOffer,
    Blog,
    BlogPost,
    DeleteAccount,
    Support,
    Contest,
};

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || Object.keys(PAGES)[0];
}

function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <Layout currentPageName={currentPage}>
            <Routes>            
                <Route path="/" element={<Home />} />
                <Route path="/Discover" element={<Discover />} />
                <Route path="/Upload" element={<Upload />} />
                <Route path="/Home" element={<Home />} />
                <Route path="/Settings" element={<Settings />} />
                <Route path="/Profile" element={<Profile />} />
                <Route path="/Leaderboard" element={<Leaderboard />} />
                <Route path="/AnnualLeaderboard" element={<AnnualLeaderboard />} />
                <Route path="/Archive" element={<Archive />} />
                <Route path="/Inbox" element={<Inbox />} />
                <Route path="/Notifications" element={<Notifications />} />
                <Route path="/MyTracks" element={<MyTracks />} />
                <Route path="/MyReviews" element={<MyReviews />} />
                <Route path="/Vote" element={<Vote />} />
                <Route path="/ReceivedFeedback" element={<ReceivedFeedback />} />
                <Route path="/BuyCredits" element={<BuyCredits />} />
                <Route path="/TrackDetails" element={<TrackDetails />} />
                <Route path="/PublicProfile" element={<PublicProfile />} />
                <Route path="/DevDashboard" element={<DevDashboard />} />
                <Route path="/Moderation" element={<Moderation />} />
                <Route path="/HowItWorks" element={<HowItWorks />} />
                <Route path="/ForArtists" element={<ForArtists />} />
                <Route path="/ForCurators" element={<ForCurators />} />
                <Route path="/submithub-alternative" element={<SubmithubAlternative />} />
                <Route path="/playlist-push-alternative" element={<PlaylistPushAlternative />} />
                <Route path="/cheapest-playlist-pitching" element={<CheapestPlaylistPitching />} />
                <Route path="/vs" element={<SoundopeVs />} />
                <Route path="/FAQ" element={<FAQ />} />
                <Route path="/CookiePolicy" element={<CookiePolicy />} />
                <Route path="/EULA" element={<EULA />} />
                <Route path="/EULAAcceptance" element={<EULAAcceptance />} />
                <Route path="/TOS" element={<TOS />} />
                <Route path="/TOSAcceptance" element={<TOSAcceptance />} />
                <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                <Route path="/PrivacyPolicyAcceptance" element={<PrivacyPolicyAcceptance />} />
                <Route path="/Report" element={<Report />} />
                <Route path="/Disclaimer" element={<Disclaimer />} />
                <Route path="/AcceptableUsePolicy" element={<AcceptableUsePolicy />} />
                <Route path="/ReviewerLeaderboard" element={<ReviewerLeaderboard />} />
                <Route path="/ViewFeedback" element={<ViewFeedback />} />
                <Route path="/FreshDopeSounds" element={<FreshDopeSounds />} />
                <Route path="/Auth" element={<Auth />} />
                <Route path="/auth" element={<Auth />} />
                <Route path={RESET_PASSWORD_ROUTE} element={<ResetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path={FORGOT_PASSWORD_ROUTE} element={<ForgotPassword />} />
                <Route path="/Submit" element={<Submit />} />
                <Route path="/SubmitOptions" element={<SubmitOptions />} />
                <Route path="/submit-options" element={<SubmitOptions />} />
                <Route path="/submit-success" element={<SubmitSuccess />} />
                <Route path="/premium-pitch" element={<PremiumPitch />} />
                <Route path="/PremiumPitch" element={<PremiumPitch />} />
                <Route path="/PurchaseHistory" element={<PurchaseHistory />} />
                <Route path="/Shop" element={<Shop />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/GrowthProgram" element={<GrowthProgram />} />
                <Route path="/Cashout" element={<Cashout />} />
                <Route path="/cashout" element={<Cashout />} />
                <Route path="/CuratorSubmit" element={<CuratorSubmit />} />
                <Route path="/curator-submit" element={<CuratorSubmit />} />
                <Route path="/Tools" element={<Tools />} />
                <Route path="/tools" element={<Tools />} />
                <Route path="/DeadWords" element={<DeadWords />} />
                <Route path="/dead-words" element={<DeadWords />} />
                <Route path="/WhatWeOffer" element={<WhatWeOffer />} />
                <Route path="/what-we-offer" element={<WhatWeOffer />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/Blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/delete-account" element={<DeleteAccount />} />
                <Route path="/DeleteAccount" element={<DeleteAccount />} />
                <Route path="/Support" element={<Support />} />
                <Route path="/support" element={<Support />} />
                <Route path="/Contest" element={<Contest />} />
                <Route path="/contest" element={<Contest />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Layout>
    );
}

export default function Pages() {
    return (
        <Router>
            <ScrollToTop />
            <PagesContent />
        </Router>
    );
}
